import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTotalWorkUnitsFetch } from './Hooks';
import { Alert, Icon, Spin, Popover } from 'antd';
import styles from './TotalWokUnits.module.less';

type DashboardSelectionProps = {
  runId: string | null;
};

const LoadingIcon = <Icon type="loading" spin />;
const InfoPopoverContent = ({ content }: { content: string }) => <div className={styles.topInfoBox}>{content}</div>;

type WorkUnitBlockProps = {
  title: string;
  content: string | undefined;
  loading: boolean;
  error: boolean;
  popoverContent: string;
};
const WorkUnitBlock: React.FC<WorkUnitBlockProps> = ({ title, content, loading, error, popoverContent }) => (
  <div style={{ textAlign: 'center', marginBottom: '0px', width: '400px' }}>
    <Popover content={<InfoPopoverContent content={popoverContent} />} trigger="hover" placement="top">
      <FontAwesomeIcon icon={['fal', 'info-circle']} className={styles.infoicons} />
    </Popover>
    <h2>{title}</h2>
    {error && <Alert message="Error" description="An error, Please try again later!" type="error" showIcon />}
    {loading && !error ? (
      <div className={styles.matches_loader_container}>
        <Spin indicator={LoadingIcon} size="large" spinning={loading} />
      </div>
    ) : (
      <h1 className={styles.h1_weight}>{content}</h1>
    )}
  </div>
);

const TotalWokUnits: React.FC<DashboardSelectionProps> = ({ runId }) => {
  const [{ data: TotalWUnits, loading: loadingTotalWUnits, error: activeError }] = useTotalWorkUnitsFetch(
    runId ?? '-1'
  );
  return (
    <div>
      <div style={{ display: 'flex', marginBottom: '0px' }}>
        <div className={styles.border}>
          <WorkUnitBlock
            title="Total Work Units"
            content={TotalWUnits?.totalWorkunit}
            loading={loadingTotalWUnits}
            error={activeError}
            popoverContent="The count of work units associated with this run."
          />
        </div>
        <div className={styles.border}>
          <WorkUnitBlock
            title="% of Work Units Completed"
            content={TotalWUnits?.completedWU}
            loading={loadingTotalWUnits}
            error={activeError}
            popoverContent="The percentage of work units in completed state."
          />
        </div>
        <WorkUnitBlock
          title="Run Start Time"
          content={TotalWUnits?.runStartTime}
          loading={loadingTotalWUnits}
          error={activeError}
          popoverContent="Time of run started."
        />
      </div>
    </div>
  );
};

export default TotalWokUnits;
